import React from 'react';
import Header from '../components/layout/Header';
import { Footer } from '../components/marketing';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Header />
      <div className="pt-24 pb-16 px-4 md:pt-32 md:pb-24 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-display-lg font-display text-[#F5F1E8] uppercase mb-2">Terms of Service</h1>
          <p className="text-xs font-mono text-[rgba(245,241,232,0.48)] mb-12 tracking-wider">LAST UPDATED: MARCH 2026</p>

          <div className="prose-fray space-y-8">
            <Section title="1. Acceptance of Terms">
              <p>By accessing or using Fray ("the Service"), you agree to be bound by these Terms of Service. If you are using the Service on behalf of an organization, you represent that you have authority to bind that organization.</p>
            </Section>

            <Section title="2. Description of Service">
              <p>Fray provides AI-powered multi-model debate and decision analysis tools. The Service includes web applications, APIs, MCP server integrations, and related documentation.</p>
            </Section>

            <Section title="3. Accounts & Registration">
              <p>You must provide accurate information when creating an account. You are responsible for maintaining the security of your account credentials. You must notify us immediately of any unauthorized access.</p>
              <p>Enterprise accounts are subject to additional terms outlined in your Enterprise Agreement.</p>
            </Section>

            <Section title="4. Acceptable Use">
              <p>You agree not to:</p>
              <ul>
                <li>Use the Service for any illegal purpose</li>
                <li>Attempt to reverse-engineer, decompile, or extract model prompts or system configurations</li>
                <li>Interfere with the Service's infrastructure or other users' access</li>
                <li>Resell or redistribute the Service without authorization</li>
                <li>Use automated tools to scrape or bulk-access the Service beyond API rate limits</li>
              </ul>
            </Section>

            <Section title="5. Data Handling">
              <p>Your debate prompts, context documents, and decision outputs ("User Content") remain your property. We do not claim ownership of User Content.</p>
              <p>We process User Content solely to provide the Service. Model providers (OpenAI, Anthropic, Google) process User Content under their respective data processing agreements, all of which include training opt-out provisions.</p>
              <p>BYOK (Bring Your Own Key) users' API calls are routed directly to model providers. Fray does not intercept, store, or log model responses in BYOK mode.</p>
            </Section>

            <Section title="6. Service Level Agreement">
              <p>For Enterprise customers: we target 99.9% uptime for the web application and API. Scheduled maintenance windows are communicated 48 hours in advance. Unscheduled downtime triggers investigation and root cause analysis shared with affected customers.</p>
              <p>Free and Pro tier users: the Service is provided on a commercially reasonable basis without uptime guarantees.</p>
            </Section>

            <Section title="7. Liability Limitations">
              <p>The Service provides AI-generated analysis for informational purposes. Fray does not provide legal, financial, medical, or professional advice. You are solely responsible for decisions made using the Service's output.</p>
              <p>To the maximum extent permitted by law, Fray's total liability shall not exceed the fees you paid in the 12 months preceding the claim.</p>
            </Section>

            <Section title="8. Termination">
              <p>Either party may terminate at any time. Upon termination, we will delete your User Content within 30 days unless legally required to retain it. Enterprise customers may request an export of all workspace data before termination.</p>
            </Section>

            <Section title="9. Changes to Terms">
              <p>We may update these Terms with 30 days' notice for material changes. Continued use of the Service after changes take effect constitutes acceptance.</p>
            </Section>

            <Section title="10. Contact">
              <p>Questions about these Terms should be directed to legal@getfray.ai.</p>
            </Section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-sm font-mono text-[#F5F1E8] font-medium tracking-wider uppercase mb-3">{title}</h2>
      <div className="text-sm text-[rgba(245,241,232,0.72)] leading-relaxed font-body space-y-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_li]:text-[rgba(245,241,232,0.64)]">
        {children}
      </div>
    </div>
  );
}
